import { textAtomTypeId } from '@/enums';
import { useEntityTextSave } from './useEntityTextSave';

interface UpdateFragmentLoglineData {
    fragmentId: number;
    content: string;
    textAtomId?: number;
}

// Fragments use fragment_logline (38) — distinct from episode_logline (9).

export function useUpdateFragmentLogline() {
    return useEntityTextSave<UpdateFragmentLoglineData>({
        entity: 'fragment',
        action: 'updateLogline',
        typeId: textAtomTypeId.fragment_logline,
        entityIdOf: ({ fragmentId }) => fragmentId,
    });
}
